import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState } from '../.././Componet';
import { useParams } from "react-router-dom";
import { Route } from "react-router-dom";
import { Modal } from 'bootstrap';

function BackupPage(props) {

    const backup = (type) => 
    {
        let h = new Helper();
        let name = h.MilToPer(new Date());
        name = name.replace('/', '');
        name = name.replace('/', '');
        h.viewFile('/Backup/' + type, 'backup_' +name +'.' + type)
    }

    return <FromBasic>
        خروجی پشتیبان :
        <SimpleButton title="sql" onClick={() => { backup('sql'); }}></SimpleButton>
        <SimpleButton title="json" onClick={() => { backup('Json'); }}></SimpleButton>
    </FromBasic>



}

export function BackupServiceApp(props) {
    return [<Route path="Backup" element={<BackupPage />} />];
}